module.exports = __webpack_public_path__ + "img/goBg.8b9744e3.png";